import { IResource } from "../i18n";

// tslint:disable-next-line: variable-name
const translation_es: IResource = {
    feedback_button_text: "Envía",
    feedback_cta_0_3: "Lo sentimos mucho, por favor, díganos qué debemos arreglar",
    feedback_cta_4_6: "Eso es una lástima, ¿nos diría qué hay que mejorar?",
    feedback_cta_7_8: "¿Qué podemos hacer para mejorarlo?",
    feedback_cta_9_10: "¡Fantástico! ¿Puedes decirnos qué es lo que más te ha gustado?",
    feedback_mail_subject: "Conoce el feedback de la aplicación",
    feedback_text_legend: "Estamos igualmente agradecidos por los comentarios tanto negativos como positivos",
    feedback_text_title: "Proporcione sus opiniones aquí (opcional)",
    feedback_title_finished: "Tu encuentro ha terminado",
    feedback_title_ongoing: "Por favor, ayúdanos a mejorar Meet",
    feedback_title_question: "¿Qué probabilidad hay de que le recomiendes Meet a un amigo o colega?",
    feedback_value_best: "Es muy probable",
    feedback_value_worst: "No es probable en absoluto",

    onboarding_button_jointext: "Únete a Meet",
    onboarding_description_four: "Botón.",
    onboarding_description_one: "Como eres usuario por primera vez, puedes personalizar la forma en que los demás te verán en este Meet.",
    onboarding_description_three: "UNETE A MEET",
    onboarding_description_two: "Una vez que esté listo, sólo tiene que hacer clic ",
    onboarding_label_color: "Color",
    onboarding_label_consentAgree: "Estoy de acuerdo con las",
    onboarding_label_consentPrivacy: "Políticas de privacidad",
    onboarding_label_consentAnd: "y",
    onboarding_label_consentTermsOfUse: "Condiciones de uso de Meet",
    onboarding_label_darkTheme: "Tema oscuro",
    onboarding_label_firstName: "Tu nombre (opcional)",
    onboarding_label_green: "Verde",
    onboarding_label_indigo: "Indigo",
    onboarding_label_lastName: "Su apellido (opcional)",
    onboarding_label_lightTheme: "Tema claro",
    onboarding_label_orange: "Naranja",
    onboarding_label_pink: "Rosado",
    onboarding_label_purple: "Morado",
    onboarding_label_teal: "Verde Azulado",
    onboarding_label_theme: "Tema",
    onboarding_label_yellow: "Amarillo",
    onboarding_title: "¡Encantado de conocerte!",

    invite_legend_text: "Envía este enlace a la persona que quieras en la llamada",
    invite_link_copy: "Copiar enlace",
    invite_link_defaultCopied: "¡Vínculo copiado al portapapeles!",
    invite_link_email: "Invitación por correo",
    invite_link_label: "Su url de invitación",
    invite_link_sms: "Invitación por SMS",

    invite_mail_body: "Hola, por favor acompáñame a mi encuentro!",
    invite_mail_signature: "Saludos",
    invite_mail_subject: "Su enlace para unirse a Meet",
    invite_title_text: "INVITAR A ALGUIEN A TU ENCUENTRO",

    citypicker_label: "Ciudad",
    citypicker_nomatch: "No hay lugares que concuerden",

    userprofile_city_label: "Ciudad",
    userprofile_color_label: "Color",
    userprofile_email_label: "Dirección de correo electrónico",
    userprofile_label_green: "Verde",
    userprofile_label_indigo: "Indigo",
    userprofile_label_orange: "Naranja",
    userprofile_label_pink: "Rosa",
    userprofile_label_purple: "Morado",
    userprofile_label_teal: "Verde Azulado",
    userprofile_label_yellow: "Amarillo",
    userprofile_locale_label: "Lengua",
    userprofile_name_label: "Nombre",
    userprofile_surname_label: "Apellido",
    userprofile_theme_label: "Tema",
    userprofile_themedark_label: "Tema oscuro",
    userprofile_themelight_label: "Tema claro",

    options_tab_profile: "Perfil",

    consentdialog_button_cancel: "Cancelar",
    consentdialog_button_ok: "OK",

    layout_meet_end: "Terminar Meet",
    layout_meet_leave: "Dejar Meet",

    layout_sidebar_labelClose: "Cerrar el menú de la barra lateral",
    layout_sidebar_labelOpen: "Abrir el menú de la barra lateral",
    layout_sidebar_labelTitle: "Abrir el menú de la barra lateral",
    layout_title_text: "Meet | Entrevistas sin problemas",

    layout_toolbar_enter: "Entrar en pantalla completa",
    layout_toolbar_invite: "Invitar",
    layout_toolbar_invite_tooltip: "Invitar a otras personas a este Meet",
    layout_toolbar_leave: "Salir de pantalla completa",

    layout_dialog_descriptionEnd: "Esto pondrá fin a el Meet para todos los participantes",
    layout_dialog_titleEnd: "¿Estás seguro de que quieres terminar este Meet?",
    layout_dialog_titleLeave: "¿Estás seguro de que quieres dejar este Meet?",

    layout_dialog_descriptionLeave: "Esto NO va a finalizar El Meet para los otros participantes",
    layout_sidebar_explorer: "Ayuda",
    layout_sidebar_feedback: "Comparte tu opinión",
    layout_sidebar_settings: "Ajustes",

    layout_finish_endmeet: "Terminar la reunión actual",
    layout_finish_leavemeet: "Deje la reunión actual",

    layout_cta_register: "¿Necesitas un Meet de 60 minutos gratis?",
    layout_cta_register_tooltip: "Regístrate para obtener un crédito de $10 dólares gratis",

    layout_dialog_descriptionAbandon: "Parece que eres el único en la llamada",
    layout_dialog_titleAbandon: "¿Querrías terminar este Meet?",

    language_de_title: "Deutsche",
    language_fr_title: "Français",
    language_en_title: "English",
    language_es_title: "Español",
    language_srLatn_title: "Srpski",
    language_srCyrl_title: "Српски",
    language_it_title: "Italian",
    language_pl_title: "Polski",

    meeting_finished_title: "TERMINÓ LA REUNIÓN",
    meeting_finished_tooltip: "Acceso de sólo lectura",

    layout_reactivate_button: "Reactivar Meet",
    layout_reactivate_tooltip: "Haz clic aquí si quieres reabrir y usar este Meet terminado. ",
    layout_dialog_titleReactivate: "¿Estás seguro de que quieres reactivar este Meet?",
    layout_dialog_descriptionReactivate: "Esto reabrirá la reunión para unirse, editar y otras modificaciones ",

    toast_reconnecting_title:  "Problema de señales de llamadas",
    toast_reconnecting_message: "Conexión (state:{state}) perdida por error {error}. Reconectando...",
    toast_reconnected_title: "Señales de llamada",
    toast_reconnected_message: "Connection reestablished. State: {state}",
    toast_disconnected_title: "Error de señales de llamada ",
    toast_disconnected_message: "{state}) cerrado por error {error}. " +
                                "Intente refrescar esta página para reiniciar la conexión.",

    config_title_text: "Crear nuevo Meet",
    config_title_ctaOne: "Por favor, defina los elementos de una nueva Reunión que desea crear.",
    config_title_ctaTwo: "Todos los datos de entrada son opcionales y se pueden omitir.",
    config_title_label: "Título",
    config_description_label: "Descripción",
    config_duration_label: "Duración",
    config_tool_label: "Conoce herramientas",
    config_tool_call: "Conoce videollamada",
    config_tool_editor: "Editor de código",
    config_tool_whiteboard: "Pizarra",
    config_passcode_label: "Conocer código de acceso (si existe)",

    search_placeholder_text: "Introduzca los criterios de búsqueda",
    createMeeting_button_create: "Crear Meet",

    projectboard_scheduleinfo_none: "La reunión no tiene fecha de inicio definida, así que puede ser usada en cualquier momento",
    projectboard_scheduleinfo_anytime: "en cualquier momento",

    projectboard_join_anyone: "Cualquiera con un enlace puede unirse",
    projectboard_role_guest: "Invitado",
    projectboard_role_interviewee: "Candidato",
    projectboard_role_interviewer: "Entrevistador",
    projectboard_role_organizer: "Organizador",

    projectboard_status_draft: "En borrador",
    projectboard_status_scheduling: "Programación",
    projectboard_status_schedulingFailed: "La programación falló",
    projectboard_status_pending: "Pendiente",
    projectboard_status_ready: "Listo",
    projectboard_status_starting: "Empezando",
    projectboard_status_inprogress: "En curso",
    projectboard_status_onhold: "En espera",
    projectboard_status_completed: "Completado",
    projectboard_status_canceled: "Cancelado",
    projectboard_status_archived: "Archivado",
    projectboard_status_feedbackWait: "Esperando por la información",
    projectboard_status_feedbackDone: "Información recopilada",
    projectboard_status_feedbackFail: "La recolección de información falló",

    projectboard_status_stopped: "Detenido",

    minibar_dashboard_title: "Tablero",

    layout_sidebar_rateus: "Calificarnos",

    invite_passcode_label: "Contraseña",

    invite_text_copy: "Invitación de copia",
        
    invite_text_body: "Por favor, únase a mi Meet at {url}",
    
    invite_passcode_body: "Por favor, únase a mi Meet at {url} y use el código de acceso {passcode}",

    invite_text_copied: "El texto de la invitación de la reunión se copia en el portapapeles.",

    invite_pascode_add: "Añadir código de acceso a url",

    participant_join_message: "{participant} se había unido a la reunión.",
    participant_left_message: "{participant} había salido de la reunión.",

    minibar_dashboard_tooltip: "Gestione sus entrevistas",

    layout_sidebar_snapshot: "Instantánea",

    snapshots_none_text: "Tome una o más instantáneas del editor de código y la pizarra y revíselos después de Meet.",
    snapshot_toast_text: "Instantánea tomada",
    snapshots_cta_text: "Tomar instantánea (F9)",
    snapshot_sentiment_positive: "Instantánea positiva",
    snapshot_sentiment_negative: "Instantánea negativa",
    snapshot_sentiment_note: "Nota",

    snapshot_personal_value: "Instantánea personal",
    snapshot_personal_title: "Visible sólo para ti",
    snapshot_team_value: "Instantánea de equipo",
    snapshot_team_title: "Visible sólo para tu equipo.",
    snapshot_public_title: "Visible para todos los participantes",
    snapshot_public_value: "Instantánea pública",

    snapshots_live_text: "Volver a la entrevista en vivo",
    
    snapshot_action_delete: "Eliminar",
    snapshot_action_load: "Cargar instantánea",

    snapshot_delete_dialog_title: "¿Eliminar instantánea?",
    snapshot_delete_dialog_description: "Confirme que desea eliminar esta instantánea",
    snapshots_final_back: "Volver al estado final de Meet",
};

export default translation_es;
